/**
 * Name and general concept taken from Material UI Color System.
 *
 * @see https://material.io/design/color/the-color-system.html
 */
import colorlib from 'color';
import { Color } from '~common/model/basics';

export type ColorType = Color | string;

const palette = {
  purple: {
    primary: '#8222FF',
    secondary: '#9A5FFD',
    inactive: '#411180',
    v1: '#611FB5',
  },
  yellow: '#FFD600',
  red: '#FF3B53',
  black: '#000000',
  white: '#FFFFFF',
  teal: '#3BFFD0',
  blue: '#00C2FF',
  orange: '#FF8C35',
  green: '#00CF56',
  gray: {
    v1: '#808080',
    v2: '#4C4C4C',
    v3: '#333333',
    v4: '#CCCCCC',
    v5: '#CFCFCF',
    v6: '#1F1F1F',
    v7: '#B2B2B2',
    v8: '#505050',
    v9: '#191919',
    v10: '#838383',
    v11: '#414141',
    v12: '#565656',
    v13: '#151515',
    v14: '#0F0F0F',
    v15: '#131313',
    v16: '#8A8A8A',
    v17: '#0B0B0B',
    v18: '#1C1C1C',
    v19: '#171717',
    v20: '#101010',
  },
};

const coreColors = {
  error: palette.red,
  background: palette.black,
  hover: palette.purple.primary,
  selected: palette.purple.primary,
  transparent: 'transparent',
};

export const getColorCode = (color: Color): string => {
  switch (color) {
    case Color.Purple:
      return palette.purple.primary;
    case Color.InactivePurple:
      return palette.purple.inactive;
    case Color.White:
      return palette.white;
    case Color.Red:
      return palette.red;
    case Color.Charcoal:
      return palette.gray.v11;
    case Color.LightGray:
      return palette.gray.v7;
    case Color.Gray:
      return palette.gray.v3;
    case Color.DimGray:
      return palette.gray.v6;
    case Color.InactiveGray:
      return palette.gray.v1;
    case Color.LoopGray:
      return palette.gray.v2;
    case Color.Black:
      return palette.black;
    case Color.Blue:
      return palette.blue;
    case Color.Green:
      return palette.green;
    case Color.Orange:
      return palette.orange;
    case Color.Yellow:
      return palette.yellow;
    case Color.Transparent:
      return 'transparent';
    default:
      throw Error('Color not found');
  }
};

export const getColor = (color: ColorType): string => {
  if (typeof color === 'string') {
    return color;
  }
  return getColorCode(color);
};

export const withAlpha = (color: ColorType) => (alphaValue: number): string => {
  return colorlib(getColor(color)).alpha(alphaValue).string();
};

export const colors = {
  ...coreColors,
  ...palette,
  withAlpha,
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/theme/colors.ts